<template>
  <div class="left">
    <div class="box1"><span></span></div>
    <div class="box2"><span></span></div>
    <div class="box3"><span ></span></div>
    <div class="img">
      <div  class="toiletNum">{{toiletNum[1]}} 个</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "iconEffect",
  props: {
    toiletNum:null,
  },
  data() {
    return {};
  },
  methods: {
      
  },
  mounted() {},
};
</script>
<style scoped>
.left{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.left {
  position: relative;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: .12rem solid #339ce1;
  border-radius: 50%;
  width: 7.0rem;
  height: 7.0rem;
  -webkit-box-shadow: 0 0 1.2rem #339ce1;
  box-shadow: 0 0 1.2rem #339ce1;
}

.box1, .box2, .box3 {
  width: 7.0rem;
  height: 7.0rem;
  position: absolute;
  -webkit-animation: circleRoate 5s linear infinite;
  animation: circleRoate 5s linear infinite;
}

@keyframes circleRoate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}

@-webkit-keyframes circleRoate /*Safari and Chrome*/
{
  0% {
    -webkit-transform: rotate(
      0deg
    );
  }
  100% {
    -webkit-transform: rotate(
      1turn
    );
  }
}

.left .box1 span {
  position: absolute;
  left: 3.15rem;
  top: 6.75rem;
  width: .7rem;
  height: .7rem;
  border-radius: 50%;
  background: #339ce1;
  -webkit-box-shadow: 0 0 1rem #339ce1;
  box-shadow: 0 0 1rem #339ce1;
}

.left .box2 span {
  position: absolute;
  left: 6.2rem;
  top: 1.4rem;
  width: .7rem;
  height: .7rem;
  border-radius: 50%;
  background: #339ce1;
  -webkit-box-shadow: 0 0 1rem #339ce1;
  box-shadow: 0 0 1rem #339ce1;
}

.left .box3 span {
  position: absolute;
  left: 0rem;
  top: 1.4rem;
  width: .7rem;
  height: .7rem;
  border-radius: 50%;
  background: #339ce1;
  -webkit-box-shadow: 0 0 1rem #339ce1;
  box-shadow: 0 0 1rem #339ce1;
}

.left >>> .el-image__inner {
  width: 60%;
}
.toiletNum{
  /* transform: rotate(-5deg); */
   color: #11E2FF;
  font-family: "nmb";
  font-size: 1.3vw;
  /* margin:-1.5rem 0 0 -1rem;} */}
</style>



// WEBPACK FOOTER //
// src/components/html/iconEffect.vue